module.exports = __webpack_public_path__ + "static/media/footer_mobile.25eb4e29.jpg";